import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { DynamicForm } from '../../../interfaces/dynamic-form';
import { FormParams } from '../../../interfaces/form-params';
import { BmCache } from '../../../../data-access/services/bm-cache.service';

@Component({
  selector: 'bm-enum-form',
  templateUrl: './enum-form.component.html',
  styleUrls: ['./enum-form.component.scss']
})
export class EnumFormComponent implements DynamicForm, OnInit {


  @HostBinding('class')
  @Input() className = '';

  @Input() params: FormParams;



  options: any[] = [];

  constructor(private cache: BmCache) {}


  async ngOnInit() {

    this.options = await this.cache.loadEnums(this.params.params.optionsKeyword);

    if (this.params.compactValue) {

      const ids = this.params.compactValue.split(',').map(id => +id);
      this.params.value = this.options.filter(option => {
        const idKey = Object.keys(option).find(key => key.startsWith('_'));
        return ids.includes(option[idKey]);
      });

    }
  }

}
